export default "__VITE_ASSET__CvmO8RdL__"